const READING = new Set(["base_brief", "ai_brief", "intervention"]);

export function isReadingPhase(phase: string): boolean {
  return READING.has(phase);
}

export function applyParticipantState<S>(opts: {
  prev: S | null;
  next: S;
  phaseOf: (state: S) => string;
  closeVisit: () => void;
  setState: (state: S) => void;
  scheduleFlush: () => void;
}): void {
  try {
    if (
      opts.prev &&
      isReadingPhase(opts.phaseOf(opts.prev)) &&
      opts.phaseOf(opts.prev) !== opts.phaseOf(opts.next)
    ) {
      opts.closeVisit();
    }
  } catch {
    /* tracking must not block the new state */
  }
  opts.setState(opts.next);
  try {
    opts.scheduleFlush();
  } catch {
    /* tracking must not block the new state */
  }
}

export function switchDocument(opts: { closeVisit: () => void; applyIndex: () => void }): void {
  try {
    opts.closeVisit();
  } catch {
    /* tracking must not block navigation */
  }
  opts.applyIndex();
}
